import * as React from 'react'

import * as styles from './Align.module.less'

export interface AlignLeftRigthProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
    > {
    left: React.ReactNode
    leftStyle?: React.CSSProperties
    right: React.ReactNode
    rightStyle?: React.CSSProperties
}

export const AlignLeftRight: React.FC<AlignLeftRigthProps> = props => {
    const { className, left, leftStyle, right, rightStyle, style } = props

    return (
        <div
            {...props}
            className={`${styles.alignLeftRight} ${className}`}
            style={style}
        >
            <div style={leftStyle}>{left}</div>
            <div style={rightStyle}>{right}</div>
        </div>
    )
}

export interface HorizontalListProps {
    list: React.ReactNode[]
}

export const HorizontalList: React.FC<HorizontalListProps> = props => {
    const { list } = props

    return (
        <div className={styles.horizontalList}>
            <ul>
                {list.map((c, index) => (
                    <li key={index}>{c}</li>
                ))}
            </ul>
        </div>
    )
}

export interface AlignTopBottomProps {
	bottomContent?: React.ReactNode
	topContent?: React.ReactNode
}

export const AlignTopBottom: React.FC<AlignTopBottomProps> = (props) => {
	const { bottomContent, topContent } = props

	return (
		<div className={styles.alignTopBottom}>
			<div className={styles.alignCenter}>{topContent}</div>

			<div className={styles.bottom}>
				<div className={styles.alignCenter}>{bottomContent}</div>
			</div>
		</div>
	)
}